class Buttons {
	constructor() {
		document.querySelectorAll(".editor-text a.btn").forEach(btn => {
			if (!btn.querySelector("img")) {
				btn.innerHTML = `<span>${btn.innerHTML}</span>`;
				btn.insertAdjacentHTML("beforeend", `<img srcset="/wp-content/themes/cis/images/arrow.png 1x, /wp-content/themes/cis/images/arrow@2x.png 2x">`)
			}
		});
	}
}
